var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoBehaviourData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 90,
    viewBox: "0 0 110 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8404_4668)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.0212,
    cy: 62.6013,
    rx: 6.82745,
    ry: 28.5639,
    transform: "rotate(71.6778 78.0212 62.6013)",
    fill: "url(#paint0_linear_8404_4668)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2807 14.3789C42.6557 11.7948 47.3442 11.7948 50.7193 14.3789L51.4704 14.9539C53.1764 16.2601 55.2781 16.9429 57.426 16.889L58.3716 16.8653C62.621 16.7585 66.4141 19.5144 67.6257 23.5887L67.8953 24.4954C68.5077 26.5549 69.8066 28.3427 71.576 29.5615L72.3551 30.0982C75.8556 32.5095 77.3044 36.9686 75.8898 40.977L75.575 41.869C74.8599 43.8951 74.8599 46.1049 75.575 48.131L75.8898 49.023C77.3044 53.0314 75.8556 57.4905 72.3551 59.9018L71.576 60.4385C69.8066 61.6573 68.5077 63.4451 67.8953 65.5046L67.6257 66.4113C66.4141 70.4856 62.621 73.2415 58.3716 73.1347L57.426 73.111C55.2781 73.0571 53.1764 73.7399 51.4704 75.0461L50.7193 75.6211C47.3443 78.2052 42.6558 78.2052 39.2807 75.6211L38.5296 75.0461C36.8236 73.7399 34.7219 73.0571 32.574 73.111L31.6284 73.1347C27.379 73.2415 23.5859 70.4856 22.3743 66.4113L22.1047 65.5046C21.4923 63.4451 20.1934 61.6573 18.424 60.4385L17.6449 59.9018C14.1444 57.4905 12.6956 53.0314 14.1102 49.023L14.425 48.131C15.1401 46.1049 15.1401 43.8951 14.425 41.869L14.1102 40.977C12.6956 36.9686 14.1444 32.5095 17.6449 30.0982L18.424 29.5615C20.1934 28.3427 21.4923 26.5549 22.1047 24.4954L22.3743 23.5887C23.5859 19.5144 27.379 16.7585 31.6284 16.8653L32.574 16.889C34.7219 16.9429 36.8236 16.2601 38.5296 14.9539L39.2807 14.3789Z",
    fill: "white",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6715 25.1492C45.3713 24.6354 44.6287 24.6354 44.3285 25.1492L38.371 35.3441C38.2612 35.532 38.0778 35.6652 37.8652 35.7116L26.3283 38.2271C25.7468 38.3539 25.5173 39.0601 25.9132 39.5044L33.7682 48.3207C33.913 48.4832 33.983 48.6988 33.9614 48.9154L32.7887 60.6649C32.7296 61.2571 33.3303 61.6936 33.8753 61.4544L44.6874 56.7082C44.8866 56.6208 45.1134 56.6208 45.3126 56.7082L56.1247 61.4544C56.6697 61.6936 57.2704 61.2571 57.2113 60.6649L56.0386 48.9154C56.017 48.6988 56.087 48.4832 56.2318 48.3207L64.0868 39.5044C64.4827 39.0601 64.2532 38.3539 63.6717 38.2271L52.1348 35.7116C51.9222 35.6652 51.7388 35.532 51.629 35.3441L45.6715 25.1492Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8404_4668",
    x: 46.3193,
    y: 47.0264,
    width: 63.4038,
    height: 31.1504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25,
    result: "effect1_foregroundBlur_8404_4668"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8404_4668",
    x1: 72.5878,
    y1: 34.0374,
    x2: 49.2375,
    y2: 66.7143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBehaviourData);
export default __webpack_public_path__ + "static/media/no-behaviour-data.357088ec9aa69cb3ea9465f498e17801.svg";
export { ForwardRef as ReactComponent };